import TopBar from 'components/layout/TopBar';
import { genKey, setStorage } from 'components/utils/Storage';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ClipLoader } from 'react-spinners';
import AgGrid from '../../components/agGrid/AgGrid';
import InputNumberRenderer from '../../components/agGrid/InputNumberRenderer';
import MyInput from '../../components/form/MyInput';
import MySelect from '../../components/form/MySelect';
import { callAxios } from '../../components/utils/FormatData';
import { URL_API } from '../../constants/settings';
import useWindowSize from '../../hooks/useWindowSize';


const ParamAlarmIndice = (props) => {
  const [width, height] = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [needUpdate, setNeedUpdate] = useState(false);
  const [typesFamilles, setTypesFamilles] = useState([]);
  const [gravityIndices, setGravityIndices] = useState([]);
  const [componentHeight, setComponentHeight] = useState(height - 160);
  const [filters, setFilters] = useState({ search: '', alarmFamily: '' });
  const [columnDefs] = useState([
    { headerName: 'Code', field: 'code',flex: 1, minWidth: 125, suppressMovable: true, resizable: true, sortable: true, sort: 'asc' },
    { headerName: 'Libellé', field: 'libelle',flex: 3, minWidth: 350, suppressMovable: true, resizable: true, sortable: true },
    { headerName: 'Famille', field: 'famille', flex: 1, minWidth: 150, suppressMovable: true, resizable: true, sortable: true, sort: 'asc' },
    { headerName: 'Indice de gravité', field: 'indiceGravite', flex: 1, minWidth: 100, suppressMovable: true, resizable: true, sortable: true, cellRenderer: 'inputNumberRenderer', cellRendererParams: { setNeedUpdate: setNeedUpdate, wsStatus: true } },
  ]);
  const [columnDefsDegraded] = useState([
    { headerName: 'Code', field: 'code', flex: 1, minWidth: 125, suppressMovable: true, resizable: true, sortable: true, sort: 'asc' },
    { headerName: 'Libellé', field: 'libelle',flex: 3, minWidth: 350, suppressMovable: true, resizable: true, sortable: true },
    { headerName: 'Famille', field: 'famille', flex: 1, minWidth: 150, suppressMovable: true, resizable: true, sortable: true, sort: 'asc' },
    { headerName: 'Indice de gravité', field: 'indiceGravite', flex: 1, minWidth: 100, suppressMovable: true, resizable: true, sortable: true, cellRenderer: 'inputNumberRenderer', cellRendererParams: { setNeedUpdate: setNeedUpdate, wsStatus: false } },
  ]);
  const [contratGridOptions, setContratGridOptions] = useState({
    suppressCellSelection: true,
    animateRows: true,
    suppressHorizontalScroll: false,
  });
  const frameworkComponents = {
    inputNumberRenderer: InputNumberRenderer
  };
  const alert = useAlert();
  const history = useHistory();
  const auth = useSelector(state => state["authentification"]);

  useEffect(() => {
    document.title = "SED - Indices de gravité";
    if (auth.profil !== 1 && auth.profil !== 2) {
      alert.error("Vous n'êtes pas autorisé à accéder à cet écran");
      history.push('/');
    }
  }, []);
  useEffect(() => {
    fetchListeIndices();
  }, [filters.alarmFamily]);
  useEffect(() => {
    if (document.getElementById('component-topbar')) {
      setComponentHeight(height - 90 - document.getElementById('component-topbar').clientHeight);
    }
  }, [width, height]);
  useEffect(() => {
    if (props.wsStatus !== null) {
      fetchFamilyEquipment();
    }
  }, [props.wsStatus]);

  // Transformation des données
  const transformDatas = (datas) => {
    const formattedDatas = [{ value: '', label: '' }];

    datas.map((d) => {
      formattedDatas.push({ value: d, label: d });
    });

    return formattedDatas;
  };

  // Récupération de la liste des familles d'équipement
  const fetchFamilyEquipment = () => {

    callAxios(props.wsStatus, "param_list_familles", { method: 'get', url: URL_API + '/familles' }, setLoading, alert)
      .then((res) => {
        const familyEquipmentDatas = transformDatas(res);
        setTypesFamilles(familyEquipmentDatas);
        setStorage(genKey("param_list_familles"), familyEquipmentDatas);
      });

  };

  // Récupération de la liste des indices
  const fetchListeIndices = () => {

    callAxios(props.wsStatus, "param_list_indices", { method: 'get', url: URL_API + '/types-alarme', params: filters.alarmFamily ? { famille: filters.alarmFamily } : {} }, setLoading, alert)
      .then((res) => {
        setGravityIndices(res);
        setStorage(genKey("param_list_indices"), res);
      });

  };

  // Modification de la recherche
  const changeSearchData = (e) => {
    setFilters({ ...filters, 'search': e.target.value });
  };

  // Changement de la famille recherchée
  const changeSelectValue = (v) => {
    setFilters({ ...filters, alarmFamily: v.value });
  };

  return (
    <div id="parameters" className={isMobile ? "panel-contenu-mobile-tablette" : "panel-contenu"} style={{ height: isMobile ? height - 60 : height - 90 }}>
      <TopBar title="gestion des indices de gravité des alarmes" className={isMobile ? "topbar-contenu-mobile-tablette" : "topbar-contenu"} color={props.params.color}
        buttons={
          <div className="boutons-topbar-contenu">
            <MySelect
              handleChange={props.wsStatus ? changeSelectValue : null}
              value={filters.alarmFamily}
              label={isMobile ? "Famil. équip." : "Famille d'équipement"}
              datas={typesFamilles}
              style={{ width: isMobile ? '30vw' : '20vw', marginRight: '25px', backgroundColor: !props.wsStatus ? '#8ca0a8' : '' }}
              disabled={!props.wsStatus}
            />
            <MyInput handleChange={changeSearchData} value={filters.search} label="Recherche" size="small"
              style={{ width: isMobile ? '30vw' : '10vw' }}
            />
          </div>
        } />
      <div className="composant-content-center" style={{ height: componentHeight }}>

        <ClipLoader
          color="#0094ca"
          loading={loading}
          css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
          size={50}
        />

        {!loading &&
          <AgGrid
            key={"ag-grid-ws-" + props.wsStatus}
            rowData={gravityIndices}
            columnDefs={props.wsStatus ? columnDefs : columnDefsDegraded}
            height={componentHeight}
            rowHeight={50}
            pagination={false}
            frameworkComponents={frameworkComponents}
            gridOptions={contratGridOptions}
            setGridOptions={setContratGridOptions}
            sortable={false}
            filters={filters}
            agGridName="ag-grid-overflow"
          />
        }

      </div>
    </div>
  );

};

export default ParamAlarmIndice;